var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.094 13.5703L9.15418 12.004L8.6877 11.2266L8.22123 12.004L7.28145 13.5703L7.16248 13.8231C6.63635 14.9412 7.45208 16.2266 8.6877 16.2266C9.92332 16.2266 10.7391 14.9412 10.2129 13.8231L10.094 13.5703ZM8.6877 12.7815L7.98816 13.9474L7.88633 14.1638C7.6099 14.7512 8.03849 15.4266 8.6877 15.4266C9.33691 15.4266 9.76551 14.7512 9.48907 14.1638L9.38724 13.9474L8.6877 12.7815Z",
    fill: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.22656C1.5 1.39814 2.17157 0.726562 3 0.726562H14C14.8284 0.726562 15.5 1.39814 15.5 2.22656V19.7266H1.5V2.22656Z",
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.72656,
    width: 9,
    height: 4,
    rx: 1,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 19.7266,
    width: 16,
    height: 3,
    rx: 1.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.2266L20 6.89323L21.0385 5.50853L26 10.9211V11.7266H21.5C20.6716 11.7266 20 11.055 20 10.2266Z",
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.2266H17.6429C18.6685 15.2266 19.5 16.058 19.5 17.0837V18.2266C19.5 20.1596 21.067 21.7266 23 21.7266V21.7266V21.7266C24.6569 21.7266 26 20.3834 26 18.7266V11.7266",
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9647 6.76092L17.123 4.70932C16.7478 4.43845 16.6632 3.91471 16.9341 3.53952C17.205 3.16433 17.7287 3.07976 18.1039 3.35064L20.9456 5.40223L19.9647 6.76092Z",
    stroke: "#3E3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColeta);
export default __webpack_public_path__ + "static/media/coleta.fba4fecb0e9f1b1c6e488d56eb1171ec.svg";
export { ForwardRef as ReactComponent };